import { FC } from 'react';
import { Link } from 'dibs-elements/exports/Link';

import styles from './SocialDropdownItem.scss';

type Props = {
    text: string;
    onClick: () => void;
};

const SocialDropdownItem: FC<Props> = ({ text, onClick }) => {
    return (
        <Link
            underline="none"
            className={styles.text}
            onClick={e => {
                e.preventDefault();
                onClick();
            }}
        >
            {text}
        </Link>
    );
};

export default SocialDropdownItem;
